<div *ngIf="jobInfo" class="grid-item-map">
  <div class="card">
    <div class="px-2">
      <div class="flex flex-wrap">
        <div class="flex-grow-1">
          <h2 class="jobnumber">Job {{ jobInfo?.jobNumber }}</h2>
          <div class="journeytype">
            {{ tasks.length == 1 ? 'Single Journey' : 'Multiple Journey' }}
          </div>
        </div>

        <div class="flex-shrink-1">
          <div class="pr-2 pt-2">
            <div>Total Duration: {{ totalDuration }}</div>
            <div>Total Distance: {{ mapService.getMiles(totalDistance) }} miles</div>
          </div>
        </div>

        <div class="flex-shrink-1">
          <div class="buyNowPrice">
            {{ jobInfo?.buyItNowPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
          </div>
        </div>
      </div>
    </div>

    <div style="margin-top: 10px">
      <map-control
        #directToSupplierMap
        appendTo="body"
        [tasks]="tasks"
        [readOnly]="true"
        [customStyle]="{ height: '250px' }"
      >
      </map-control>
    </div>

    <div *ngFor="let taskInfo of tasks">
      <div class="wrapperDiv">
        <div
          *ngIf="taskInfo.taskTransit != null && taskInfo.taskTransit.byRoadDurationMinutes > 0"
          class="transit"
        >
          <i class="fas fa-route"></i> Distance between tasks:
          {{ taskInfo.taskTransit.byRoadDistanceMiles }} miles - By Car:
          {{ taskInfo.taskTransit.byRoadDurationMinutes }} minutes - Public Transport:
          {{ taskInfo.taskTransit.byPublicTransportDurationMinutes }} minutes
        </div>

        <div *ngIf="taskInfo.taskTransit == null" class="hr"></div>

        <div class="flex flex-wrap">
          <div class="flex-grow-1">
            <h2 class="pickup-header">
              <i class="fa fa-map-marker"></i>&nbsp;Collection | {{ taskInfo.pickupLocation.city }}
              {{ taskInfo.pickupLocation.postcode }}
            </h2>

            <div class="address">
              {{ taskInfo.pickupLocation.addressLine1 }}
              {{ taskInfo.pickupLocation.addressLine2 }}
              {{ taskInfo.pickupLocation.addressLine3 }}
              {{ taskInfo.pickupLocation.postal_town }}
              {{ taskInfo.pickupLocation.city }}
              {{ taskInfo.pickupLocation.postcode }}
            </div>

            <div class="timing">
              {{ taskInfo.pickupEarliestDateTime | datex : "ddd DD MMM 'YY HH:mm" }} -
              {{ taskInfo.pickupLatestDateTime | datex : "ddd DD MMM 'YY HH:mm" }}
            </div>
          </div>

          <div class="flex-grow-1">
            <h2 class="dropoff-header">
              <i class="fa fa-map-marker"></i>&nbsp;Delivery | {{ taskInfo.dropoffLocation.city }}
              {{ taskInfo.dropoffLocation.postcode }}
            </h2>

            <div class="address">
              {{ taskInfo.dropoffLocation.addressLine1 }}
              {{ taskInfo.dropoffLocation.addressLine2 }}
              {{ taskInfo.dropoffLocation.addressLine3 }}
              {{ taskInfo.dropoffLocation.postal_town }}
              {{ taskInfo.dropoffLocation.city }}
              {{ taskInfo.dropoffLocation.postcode }}
            </div>

            <div class="timing">
              {{ taskInfo.dropoffEarliestDateTime | datex : "ddd DD MMM 'YY HH:mm" }} -
              {{ taskInfo.dropoffLatestDateTime | datex : "ddd DD MMM 'YY HH:mm" }}
            </div>
          </div>
          <div class="flex-shrink-1">
            <div style="padding-right: 10px; padding-top: 17px">
              <div><i class="las la-clock"></i> {{ stringToDuration(taskInfo.estimateTime) }}</div>
              <div>
                <i class="fa fa-road"></i> {{ mapService.getMiles(taskInfo.distance) }} miles
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap">
          <div class="flex-shrink-1">
            <div style="padding-top: 5px">
              <div class="vrm">{{ taskInfo.vehicle.registrationNumber }}</div>
            </div>
          </div>

          <div class="flex-grow-1">
            <div class="pl-2">
              <div class="vehicleInfo">
                <div>
                  <i class="la la-automobile"></i>
                  <span class="mmfw">
                    {{ taskInfo.vehicle.make }}
                    {{ taskInfo.vehicle.model }}
                  </span>
                </div>
                <div>
                  <span *ngIf="taskInfo?.vehicle?.fuelType"
                    ><i class="las la-gas-pump"></i>
                    <span class="mmfw">{{ taskInfo.vehicle.fuelType }}</span></span
                  >
                  <i class="las la-weight-hanging"></i>
                  <span class="mmfw">{{ taskInfo.vehicle.kerbWeight }}kg</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <span
            *ngFor="let orgStepSubCat of taskInfo.checklist?.orgStepChecklistSubCategories"
            class="orgStepSubCat"
          >
            <checklist-category-item
              [subCategory]="orgStepSubCat.checklistSubCategory"
            ></checklist-category-item>
          </span>
        </div>
      </div>
    </div>

    <!-- Reinstate to test regenerating transit times for a job
    <div style="text-align: center; margin-top: 30px;">
      <div class="button-box">
        <button (click)="regenTransit(jobInfo.id)" pButton class="button ui-button-danger"
                label="Regen Transit Times"></button>
      </div>
    </div>
    -->
  </div>

  <div class="fixed-bottom">
    <div *ngIf="jobAvailable; else jobUnavailable">
      <div class="button-box accept">
        <button
          pButton
          class="button ui-button-success accept-job"
          [label]="'Accept for &pound;' + jobInfo?.buyItNowPrice"
          (click)="acceptJobDialogVisible = true"
        ></button>
      </div>
      <div class="button-box">
        <button
          pButton
          class="button ui-button-warning"
          label="Watch"
          (click)="watchJob()"
        ></button>
      </div>
      <div class="button-box">
        <button
          pButton
          class="button ui-button-danger"
          label="Hide"
          (click)="rejectJobDialog = true"
        ></button>
      </div>
      <div class="button-box">
        <button
          pButton
          class="button ui-button-secondary"
          label="More info"
          (click)="viewMoreInfo()"
        ></button>
      </div>
    </div>

    <ng-template #jobUnavailable>
      <div class="text-center" style="font-size: 1.2rem; font-weight: bold; padding-top: 10px">
        <div *ngIf="unavailableReason == jobUnavailableReason.TakenBySomeoneElse">
          Job is no longer available
        </div>

        <div *ngIf="unavailableReason == jobUnavailableReason.JobStatusWrong">
          Job is no longer available
        </div>

        <div *ngIf="unavailableReason == jobUnavailableReason.AlreadyAccepted">
          <i class="fa fa-check-circle text-success"></i> You have accepted this job
        </div>
      </div>
    </ng-template>
  </div>
</div>

<p-dialog
  header="Reason for Hiding"
  [(visible)]="rejectJobDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '400px' }"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">Enter the reason for hiding this job</div>
  <div class="ui-grid-row">
    <div class="ui-g-12"></div>
  </div>

  <div class="ui-grid-row">
    <div style="clear: both"></div>

    <p-listbox
      [options]="rejectReasons"
      [(ngModel)]="rejectReason"
      [style]="{ width: '100%' }"
    ></p-listbox>
  </div>

  <div class="ui-grid-row" style="float: right; margin-top: 20px">
    <button
      type="button"
      [disabled]="rejectReason == null"
      class="ui-button-danger"
      pButton
      icon="fa ui-icon-trash"
      (click)="rejectJob()"
      label="Hide Job"
    ></button>
    <button
      type="button"
      pButton
      icon="fa ui-icon-close"
      label="Cancel"
      (click)="rejectJobDialog = false"
    ></button>
  </div>
</p-dialog>

<accept-job-dialog
  *ngIf="jobToAccept"
  [googleAnalyticsEventLabel]="googleAnalyticsEventLabel"
  [(visible)]="acceptJobDialogVisible"
  (jobAccepted)="loadJob()"
  [job]="jobToAccept"
  referrPage="jobListItem"
>
</accept-job-dialog>
